import { render, staticRenderFns } from "./ClaveUnica.vue?vue&type=template&id=32b2a1f9&"
import script from "./ClaveUnica.vue?vue&type=script&lang=js&"
export * from "./ClaveUnica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports